package com.sddamico.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import com.sddamico.api.SuccessResponse
import com.sddamico.api.apiPost
import com.sddamico.state.LocalAuthActions
import com.sddamico.state.LocalAuthState
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

@Composable
fun ImpersonationBanner() {
    val authState = LocalAuthState.current
    val actions = LocalAuthActions.current
    val scope = rememberCoroutineScope()
    if (authState.user?.isImpersonating != true) return

    Row(
        Modifier
            .fillMaxWidth()
            .backgroundColor(Color.rgb(0xD97706))
            .borderRadius(8.px)
            .padding(topBottom = 0.625.cssRem, leftRight = 1.cssRem)
            .margin(bottom = 1.cssRem)
            .gap(0.75.cssRem),
        verticalAlignment = Alignment.CenterVertically
    ) {
        SpanText(
            "Viewing as ${authState.user?.fullName} (${authState.user?.clubName})",
            Modifier
                .fontSize(0.8125.cssRem)
                .fontWeight(FontWeight.SemiBold)
                .color(Colors.White)
        )

        Spacer()

        Div(
            Modifier
                .backgroundColor(Colors.White)
                .color(Color.rgb(0xD97706))
                .borderRadius(6.px)
                .padding(topBottom = 0.375.cssRem, leftRight = 0.75.cssRem)
                .fontSize(0.75.cssRem)
                .fontWeight(FontWeight.Bold)
                .cursor(Cursor.Pointer)
                .onClick {
                    scope.launch {
                        try {
                            apiPost("/api/admin/stop-impersonate", null, SuccessResponse.serializer())
                            actions.refresh()
                        } catch (_: Exception) {}
                    }
                }
                .toAttrs()
        ) {
            Text("Exit View")
        }
    }
}
